import { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { isNewApp } from "../../helper/CommonFuncs";

function GTMManager({ location }) {
   const gtmId = "GTM-PPW8KTDL";

   useEffect(() => {
      const scriptSrc = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
      const allowedPaths = ["/trial", "/login", "/sign-up"];

      document.querySelector(`script[src="${scriptSrc}"]`)?.remove();

      if (allowedPaths.includes(location.pathname) && isNewApp) {
         const script = document.createElement("script");
         script.async = true;
         script.src = scriptSrc;
         document.head.appendChild(script);

         window.dataLayer = window.dataLayer || [];
         window.dataLayer.push({ event: "gtm.js" });
      }
   }, [location.pathname]);

   return null;
}

export default withRouter(GTMManager);
